
(function($) {
  $(document).ready(function() {
    
    // 1. Store active slider instances here
    const activeSwipers = {};

    // 2. Configuration for every slider on the page
    const sliderConfigs = [
      {
        id: 'ingredients',
        selector: '.ingredients-slider',
        breakpoint: 900,
        options: {
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            nextEl: '.ingredients-wrapper .swiper-button-next',
            prevEl: '.ingredients-wrapper .swiper-button-prev',
          }
        }
      },
      {
        id: 'bestsellers',
        selector: '.bestseller-slider',
        breakpoint: 768,
        options: {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: '.bestseller-slider .swiper-button-next',
            prevEl: '.bestseller-slider .swiper-button-prev',
          }
        }
      },
      {
        id: 'feature_slider',
        selector: '.omi-feature-slider',
        breakpoint: 9999, // Sets it super high so it is ALWAYS a slider on desktop & mobile
        options: {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: '.omi-feature-slider .swiper-button-next',
            prevEl: '.omi-feature-slider .swiper-button-prev',
          }
        }
      },
      {
        id: 'believe',
        selector: '.believe-slider',
        breakpoint: 900, // Matches the CSS media query breakpoint
        options: {
          slidesPerView: 1, // Shows one card centered
          spaceBetween: 20,
          navigation: {
            nextEl: '.believe-slider .swiper-button-next',
            prevEl: '.believe-slider .swiper-button-prev',
          }
        }
      },
      {
        id: 'madesafe',
        selector: '.safe-slider',
        breakpoint: 769, // Will only initialize if screen is 768px or smaller
        options: {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: '.made-safe-mobile .swiper-button-next',
            prevEl: '.made-safe-mobile .swiper-button-prev',
          }
        }
      }
    ];

    // 3. The Common Function
    function manageSwipers() {
      if (typeof Swiper === 'undefined') {
        console.warn("Swiper library is not loaded yet.");
        return;
      }

      const screenWidth = window.innerWidth;

      // Loop through our configurations
      sliderConfigs.forEach(config => {
        const isMobile = screenWidth < config.breakpoint;
        const currentSwiper = activeSwipers[config.id];

        if (isMobile && !currentSwiper) {
          // It should be a slider, but isn't yet -> Initialize it
          activeSwipers[config.id] = new Swiper(config.selector, config.options);
          
        } else if (!isMobile && currentSwiper) {
          // It shouldn't be a slider, but is -> Destroy it
          currentSwiper.destroy(true, true);
          activeSwipers[config.id] = null;
        }
      });
    }

    // Initialize on load and listen for resizes
    manageSwipers();
    $(window).on('resize', manageSwipers);

    // contact us page
    $('.scroll-to-contact').on('click', function(e) {
      e.preventDefault();

      var $targetSection = $('.omi-contact-href');

      if ($targetSection.length) {
        $('html, body').animate({
          scrollTop: $targetSection.offset().top - 80
        }, 100)
      }
    });

    
  });
})(jQuery);
